__turbopack_context__.v({
  "button": "Link-module-scss-module__BWqRRq__button",
  "contains-text": "Link-module-scss-module__BWqRRq__contains-text",
  "link": "Link-module-scss-module__BWqRRq__link",
  "text": "Link-module-scss-module__BWqRRq__text",
  "text-monochrome": "Link-module-scss-module__BWqRRq__text-monochrome",
  "text-primary": "Link-module-scss-module__BWqRRq__text-primary",
  "text-tonal": "Link-module-scss-module__BWqRRq__text-tonal",
  "variant-error": "Link-module-scss-module__BWqRRq__variant-error",
  "variant-error-outlined": "Link-module-scss-module__BWqRRq__variant-error-outlined",
  "variant-filled": "Link-module-scss-module__BWqRRq__variant-filled",
  "variant-outlined": "Link-module-scss-module__BWqRRq__variant-outlined",
  "variant-text": "Link-module-scss-module__BWqRRq__variant-text",
  "variant-tonal": "Link-module-scss-module__BWqRRq__variant-tonal",
});
